<template>
  <div class="period-picker">
    <div class="pickers-pair">
      <div class="datepicker-holder" ref="pikaDayFromHolder">
        <h5>{{ globalTexts.periodFrom }}</h5>
        <input v-model="periodFrom" ref="pikaDayFrom" />
      </div>
      <div class="datepicker-holder" ref="pikaDayToHolder">
        <h5>{{ globalTexts.periodTo }}</h5>
        <input v-model="periodTo" ref="pikaDayTo" />
      </div>
    </div>
    <div class="action-panel">
      <v-btn @click="closeForm(true)"
        ><i class="material-icons">check</i></v-btn
      >
      <v-btn @click="closeForm(false)"
        ><i class="material-icons">cancel</i></v-btn
      >
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import i18n from '@/plugins/i18n'
import Pikaday from 'pikaday'

export default {
  name: 'PeriodPick',
  props: {
    from: String,
    to: String,
  },
  data: function() {
    return {
      dateOptions: {
        format: 'DD.MM.YYYY',
        i18n: {
          previousMonth: '',
          nextMonth: '',
          months: [],
          weekdays: [],
          weekdaysShort: [],
        },
        firstDay: 1,
        defaultDate: moment().toDate(),
      },
      fullView: true,
      periodFrom: null,
      periodTo: null,
      datePickerFrom: null,
      datePickerTo: null,
    }
  },
  created() {
    this.periodFrom = moment(this.from).toDate()
    this.periodTo = moment(this.to).toDate()
    this.refreshListOptions()
  },
  mounted() {
    this.initPikadays()
  },
  methods: {
    initPikadays() {
      let that = this
      const globalTexts = i18n.messages[i18n.locale].global
      const i18Settings = {
        months: globalTexts.months.split(','),
        weekdays: globalTexts.weekdays.split(','),
        weekdaysShort: globalTexts.weekdaysShort.split(','),
      }
      this.datePickerFrom = new Pikaday({
        field: this.$refs.pikaDayFrom,
        container: this.$refs.pikaDayFromHolder,
        i18n: i18Settings,
        firstDay: 1,
        onSelect: date => {
          that.periodFrom = date
        },
      })
      this.datePickerFrom.show()
      this.datePickerFrom.hide = function() {
        /*noop*/
      }
      if (that.periodFrom) {
        this.datePickerFrom.setDate(new Date(that.periodFrom))
      }

      this.datePickerTo = new Pikaday({
        field: this.$refs.pikaDayTo,
        container: this.$refs.pikaDayToHolder,
        i18n: i18Settings,
        firstDay: 1,
        onSelect: date => {
          that.periodTo = date
        },
      })
      this.datePickerTo.show()
      this.datePickerTo.hide = function() {
        /*noop*/
      }
      if (that.datePickerTo) {
        this.datePickerTo.setDate(new Date(that.periodTo))
      }
    },
    periodDateChange() {
      this.fullView = true
      this.$emit('change', { from: this.periodFrom, to: this.periodTo })
    },
    closeForm(res) {
      if (res) {
        this.$emit('done', { from: this.periodFrom, to: this.periodTo })
      } else {
        this.$emit('done', null)
      }
    },
    setPikerReadonly(ref) {
      this.$refs[ref].$el.readOnly = true
    },
    refreshListOptions() {
      this.dateOptions.i18n.months = this.globalTexts.months.split(',')
      this.dateOptions.i18n.weekdays = this.globalTexts.weekdays.split(',')
      this.dateOptions.i18n.weekdaysShort = this.globalTexts.weekdaysShort.split(
        ','
      )
    },
  },
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/breakpoints';

.period-picker {
  padding: 20px;
  background: #424242;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}

.datepicker-holder {
  margin: 0 15px;
}
.action-panel {
  padding: 0 15px;
  > button {
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

.pickers-pair {
  display: flex;
  margin-bottom: 10px;
  @include sm {
    flex-direction: column;
  }
  /deep/ input {
    display: none;
  }
  /deep/.pika-single.is-bound {
    position: static;
    .pika-lendar {
      @include md {
        max-width: 280px;
        font-size: 12px;
      }
      .pika-next,
      .pika-prev {
        color: transparent;
      }
    }
  }
}
</style>
